import React from "react";
import { useDispatch } from "react-redux";
import { Modal, Header, Image } from "semantic-ui-react";
import { closeModal } from "../actions";
import loadingGif from "../images/30.gif";

const LoadingModal = props => {
  const dispatch = useDispatch();

  const { title } = props;

  return (
    <Modal
      closeIcon="close"
      open={true}
      onClose={() => {
        dispatch(closeModal());
      }}
      {...props}
    >
      <Modal.Content>
        <Header as="h3">{title}</Header>
        <Image src={loadingGif} />
      </Modal.Content>
    </Modal>
  );
};

export default LoadingModal;
